<h2 class="title">Skontaktuj się z nami</h2>
<div class="contact-page-holder">
  <!-- Header Section -->
  <div class="contact-header">

    <p>Jesteśmy tutaj, aby Ci pomóc. Skorzystaj z dowolnej formy kontaktu.</p>
  </div>

  <!-- Three Column Layout -->
  <div class="contact-grid">



    <!-- Column 2: Contact Information -->
    <div class="contact-column contact-info-column">
      <div class="column-header">
        <mat-icon class="header-icon">contact_phone</mat-icon>
        <h2>Dane kontaktowe</h2>
      </div>      
      <div class="column-content">
        <div class="contact-item">
          <mat-icon>location_on</mat-icon>
          <div>
            <h3>Adres biura</h3>
            <p>ul. Stary Rynek 1<br>65-001 Zielona Góra</p>
          </div>
        </div>

        <div class="contact-item">
          <mat-icon>phone</mat-icon>
          <div>
            <h3>Telefon</h3>
            <p><a href="tel:683200630">68 320 06 30</a></p>
          </div>
        </div>

        <div class="contact-item">
          <mat-icon>email</mat-icon>
          <div>
            <h3>Email</h3>
            <p><a href="mailto:biuro@zgranegrono.pl">biuro@zgranegrono.pl</a></p>
          </div>
        </div>

        <div class="contact-item">
          <mat-icon>access_time</mat-icon>
          <div>
            <h3>Godziny otwarcia</h3>
            <div class="hours-list">
              <div class="hour-item">
                <span>Poniedziałek:</span>
                <span>9:00 - 17:00</span>
              </div>
              <div class="hour-item">
                <span>Wtorek:</span>
                <span>9:00 - 15:00</span>
              </div>
              <div class="hour-item">
                <span>Środa:</span>
                <span>9:00 - 17:00</span>
              </div>
              <div class="hour-item">
                <span>Czwartek:</span>
                <span>9:00 - 15:00</span>
              </div>
              <div class="hour-item">
                <span>Piątek:</span>
                <span>9:00 - 15:00</span>
              </div>
              <div class="hour-item weekend">
                <span>Weekend:</span>
                <span>nieczynne</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Column 1: Contact Form -->
    <div class="contact-column contact-form-column">
      <div class="column-header">
        <mat-icon class="header-icon">email</mat-icon>
        <h2>Zostań partnerem</h2>
      </div>
      <div class="column-content">
        <p>Jeśli jesteście Państwo zainteresowani współpracą, prosimy o pozostawienie danych kontaktowych. Jednocześnie prosimy o cierpliwość w oczekiwaniu na kontakt z naszej strony - odezwiemy się do Państwa w ciągu maksymalnie 7 dni.</p>
        <!-- Success Message (shown after email is sent) -->
        @if (emailSent) {
          <div class="success-message-container">
            <div class="success-icon">
              <mat-icon class="success-checkmark">check_circle</mat-icon>
            </div>
            <h3>Wiadomość została wysłana!</h3>
            <p>Dziękujemy za kontakt. Wkrótce odpowiemy na Twoją wiadomość.</p>
            <button class="custom-button" mat-raised-button color="primary" (click)="sendNewEmail()">
              Wyślij nową wiadomość
            </button>
          </div>
        }

        <!-- Contact Form (shown when no email sent yet) -->
        @if (!emailSent) {
          <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                       <!-- Message Title Field -->
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Firma</mat-label>
              <input matInput formControlName="title" />
              @if (contactForm.get('title')?.hasError('required')) {
                <mat-error>
                  Nazwa firmy
                </mat-error>
              }
            </mat-form-field>

            <!-- Title Field -->
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Imię i nazwisko</mat-label>
              <input matInput formControlName="name" />
              @if (contactForm.get('name')?.hasError('required')) {
                <mat-error>
                  Imię i nazwisko jest wymagane
                </mat-error>
              }
            </mat-form-field>
            <!-- Email Field -->
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Twój adres email</mat-label>
              <input matInput type="email" formControlName="email" />
              @if (contactForm.get('email')?.hasError('email')) {
                <mat-error>
                  Proszę podać prawidłowy adres email
                </mat-error>
              }
            </mat-form-field>

            <!-- Phone Field -->
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Telefon</mat-label>
              <input matInput type="tel" formControlName="phone" />
            </mat-form-field>
 
            <!-- Message Field -->
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Twoja wiadomość</mat-label>
              <textarea matInput formControlName="message" rows="4"></textarea>
              @if (contactForm.get('message')?.hasError('required')) {
                <mat-error>
                  Wiadomość jest wymagana
                </mat-error>
              }
            </mat-form-field>
            <!-- CAPTCHA Field -->
            <div class="captcha-container">
              <p>{{ captchaQuestion }}</p>
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Zabezpieczenie przed spamem. Twoja odpowiedź</mat-label>
                <input matInput formControlName="captcha" />
                @if (contactForm.get('captcha')?.hasError('required')) {
                  <mat-error>
                    Odpowiedź jest wymagana
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <!-- Submit Button -->
            <button class="custom-button" mat-raised-button color="primary" type="submit" [disabled]="contactForm.invalid">
              Wyślij wiadomość
            </button>
          </form>
        }
      </div>
    </div>

    <!-- Column 3: Map -->
    <div class="contact-column map-column">
      <div class="column-header">
        <mat-icon class="header-icon">map</mat-icon>
        <h2>Znajdź nas</h2>
      </div>
      <div class="column-content">

        <h3>Miejsce pobrania wniosków</h3>
        <div class="map-info"><p>
          Ratusz,<br />
          ul. Stary Rynek 1<br />
          (wejście od strony ul. Kościelnej)<br />
          Zielona Góra<br />
          <br />
          Centrum Rekreacyjno-Sportowe (recepcja)<br />
          ul. Sulechowska 41<br />
          Zielona Góra
          </p>
        </div>

        <app-map-view
          [centerMap]="contactMapCenter"
          [zoomMap]="contactMapZoom"
          [pointerLocal]="contactPointerLocal">
        </app-map-view>
   
      </div>
    </div>

  </div>
</div>